import { Component } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-footer',
	standalone: true,
	imports: [SharedModule, TranslateModule],
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss', './footer.responsive.scss'],
})
export class FooterComponent {
	protected readonly currentYear = new Date().getFullYear();
}
